export const VIDEO_API_ROUTES = {
  GET_VIDEO: "admin/videos",
  GET_VIDEO_BY_ID: "admin/videos/:id",
  CREATE_VIDEO: "admin/videos",
  UPDATE_VIDEO: "admin/videos/:id",
  DELETE_VIDEO: "admin/videos/:id",
};
